import { Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Blocca l'accesso alle pagine Premium.
 * Se l'utente è free, mostra un prompt di upgrade.
 * Altrimenti renderizza i children normalmente.
 */
export function PremiumGate({ children }) {
  const { isPremium } = useAuth();
  const navigate = useNavigate();

  if (isPremium) return children;

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-6 text-center">
      <div className="w-16 h-16 rounded-2xl bg-[#0F172A] flex items-center justify-center mb-5">
        <Lock className="w-8 h-8 text-white" />
      </div>
      <h2 className="text-xl font-bold text-[#0F172A] mb-2">Funzione Premium</h2>
      <p className="text-slate-500 text-sm max-w-xs mb-6">
        Questa funzione è disponibile nel piano Premium a <strong>€4,90/mese</strong>.
        Sblocca Statistiche, Biglietti da visita, Import Excel e molto altro.
      </p>
      <button
        data-testid="upgrade-premium-btn"
        onClick={() => navigate("/app/premium")}
        className="bg-[#0F172A] text-white font-bold px-8 py-3 rounded-xl text-sm hover:bg-slate-800 transition active:scale-95"
      >
        Scopri Premium
      </button>
    </div>
  );
}
